/**
 * Created by laixinyu on 2017/3/21.
 */
import axios from 'axios';
import APIS from '../../apis';
import qs from 'qs';
import  {callbackHandler} from '../callbackHandler';

export default {
    state: {
        ANSWER_TITLE: '',
        ANSWER_SOURCE: null,
        ANSWER_TESTID: null,
        ANSWER_INTRO:'',
        ANSWER_SCALEID: '',
        ANSWER_MODULE_INTRO: '',
        ANSWER_MODULE_TITLE: '',
        MODULE_CONNECT_MODE: '',
        MULTI_MODULE: false,
        LAST_MODULE: false,
        SHOW_TIPS: false,
        QUESTIONS_TYPE: 0,
        ANSWER_CONFIGVO: '',
        ALGORITHMTYPE:false,
        REPORTVERSION:1,
        timingData: {}, // 计时数据
    },
    mutations: {
        [`SET_LAST_MODULE`](state, tof){
            state.LAST_MODULE = !!tof;
        },
        [`SET_SHOW_TIPS`](state, tof){
            state.SHOW_TIPS = !!tof;
        },
        ['SET_MODULE_CONNECT_MODE'](state, mode){
            state.MODULE_CONNECT_MODE = mode * 1;
        },
        ['SET_MULTI_MODULE'](state, tof){
            state.MULTI_MODULE = !!tof;
        },
        ['SET_ANSWER_TITLE'](state, title){
            state.ANSWER_TITLE = title==undefined?'':title;
        },
        ['SET_ANSWER_SOURCE'](state, source){
            state.ANSWER_SOURCE = source
        },
        ['SET_ANSWER_TESTID'](state, testid){
            state.ANSWER_TESTID = testid
        },
        ['SET_ANSWER_INTRO'](state, intro){
            state.ANSWER_INTRO = intro==undefined?'':intro;
        },
        ['SET_ANSWER_SCALEID'](state, scaleId) {
            state.ANSWER_SCALEID = +scaleId || ''
        },
        ['SET_ANSWER_MODULE_INTRO'](state, intro){
            state.ANSWER_MODULE_INTRO = intro==undefined?'':intro;
        },
        ['SET_ANSWER_MODULE_TITLE'](state, intro){
            state.ANSWER_MODULE_TITLE = intro==undefined?'':intro;
        },
        ['SET_QUESTIONS_TYPE'](state, source){
            console.log('设置颜色配案',source)
            state.QUESTIONS_TYPE = source
        },
        ['SET_ANSWER_CONFIGVO'](state, source){
             state.ANSWER_CONFIGVO = source
        },
        ['SET_ALGORITHM_TYPE'](state, source){
          state.ALGORITHMTYPE = source
        },
        ['SET_REPORT_VERSION'](state, source){
          state.REPORTVERSION = source
        },
        setTimingData(state, val) {
            state.timingData = val
        }
    },
    getters: {
        [`LAST_MODULE`]: state => state.LAST_MODULE,
        [`MODULE_CONNECT_MODE`]: state=>state.MODULE_CONNECT_MODE,
        [`MULTI_MODULE`]: state => state.MULTI_MODULE,
        ['ANSWER_GETCALCTITLE'](state){
            let result = '';
            if (state.ANSWER_TITLE.length > 10) {

                [...state.ANSWER_TITLE].forEach((str, index) => {
                    if (index === 8) {
                        result += '</br>'
                    }

                    result += str;
                })
            } else {
                result = state.ANSWER_TITLE
            }

            return result
        },
        // 测试标题
        ['ANSWER_TITLE']: state => state.ANSWER_TITLE,
        // 答题时测试说明内容
        ['ANSWER_INTRO']: state => state.ANSWER_INTRO,
        ['ANSWER_SCALEID']: state => state.ANSWER_SCALEID,
        // 答题时模块引导语内容
        ['ANSWER_MODULE_INTRO']: state => state.ANSWER_MODULE_INTRO,
        ['ANSWER_MODULE_TITLE']: state => state.ANSWER_MODULE_TITLE,
        [`QUESTIONS_TYPE`]: state => state.QUESTIONS_TYPE,//ui模板新增
        // 测试标题
        ['ANSWER_CONFIGVO']: state => state.ANSWER_CONFIGVO,
        ['SHOW_TIPS']: state => state.SHOW_TIPS,
        ['ALGORITHM_TYPE']: state => state.ALGORITHMTYPE,
        // 生成报告类型
        ['REPORT_VERSION']: state => state.REPORTVERSION,
        timingData: state => state.timingData
    },
    actions: {
        /**
         * 中转页请求地址
         */
        [`YXLCP_LOGIN`](context, {params}){
            return axios.get(APIS.yxlCp.logIn, {params}).then((res)=>{
                return callbackHandler(APIS.yxlCp.logIn, res);
            })
        },
        [`GET_MODULE_INTRO`](context, {params} = {}){
            if ((params.channelId == 2278 || params.channelId == 2310) && (params.questionnaireId == 424 || params.questionnaireId == 442)) {
                console.log('2278 2310渠道且566ID的getScaleIntro接口数据，后续需要处理')
                return Promise.resolve(require('./getCurModuleIntro_id566.json'))
            }else{
                return axios.get(APIS.yxlCp.curModuleintro, {params}).then((res)=>{
                    if (+res.data.code === 1 ) {
                        const data = res.data.data
                        context.commit('setTimingData', data)
                        return res.data
                    }
                    return {
                        code: res.data.code,
                        data: {}
                    }
                })
            }
        },
        /**
         * 获取测评介绍
         * @param context
         * @param env
         * @param params
         * @returns {*}
         */
        [`GET_SCALE_INTRO`](context, {env, params}={}){
            if ((params.channelId == 2278 || params.channelId == 2310) && (params.questionnaireId == 424 || params.questionnaireId == 442)) {
                console.log('2278 2310渠道且566ID的getScaleIntro接口数据，后续需要处理')
                return Promise.resolve(require('./getScaleIntro_id566.json'))
            }else{
                const api = APIS[env].intro;
                return axios.get(api, {params}).then((res)=>{
                    if (res.data.code == 1) {
                        localStorage.setItem('localScaleModules', JSON.stringify({
                            scaleId: res.data.data.scaleId,
                        }))
                        context.commit('SET_ANSWER_SCALEID', res.data.data.scaleId)
                    }
                    return callbackHandler(api, res);
                })
            }

        },
        /**
         * 设置性别
         * @param context
         * @param env
         * @param params
         * @returns {*}
         */
        [`SET_SCALE_GENDER`](context, {env, params}={}){
            const api = APIS[env].setGender;
            return axios.get(api, {params}).then((res)=>{
                return callbackHandler(api, res);
            })
        },
        /**
         * 获取做题题目
         * @param context
         * @param params => accountId
         * @returns {*}
         */
        ['GET_QUESTIONS'](context, {env, params}={}){
            const api = APIS[env].questions;
            return axios.get(api, {params}).then((res)=>{
                return callbackHandler(api, res);
            })
        },
        /**
         * 提交单题答案
         * @param context
         * @param env
         * @param params
         * @returns {*}
         */
        [`SET_SCALE_COMMIT_STEP`](context, {env, params}={}){
            //更换接口路由
            let touTiaoMiniApp = [2345, 2293, 2545].includes(Number(params.channelId))
            let api = !touTiaoMiniApp?APIS[env].commitStep:APIS.touTiaoMiniAppCommitAnswer

            return axios.post(api, qs.stringify(params)).then((res)=>{
                return callbackHandler(api, res);
            })
        },
        /**
         * 清空所有答案，重新做题
         * @param context
         * @param env
         * @param params
         * @returns {*}
         */
        [`SET_SCALE_COMMIT_CLEAR`](context, {env, params}={}){
            const api = APIS[env].commitClear;
            return axios.get(api, {params}).then((res)=>{
                 callbackHandler(api, res)
                 return res.data
            })
        },
        /**
         * 提交所有答案，生成报告
         * @param context
         * @param env
         * @param params
         * @returns {*}
         */
        [`SET_SCALE_COMMIT_ALL`](context, {env, params}={}){
            //更换接口路由
            let touTiaoMiniApp = [2345, 2293, 2545].includes(Number(params.channelId))
            let api = !touTiaoMiniApp?APIS[env].commitAll:APIS.touTiaoMiniAppCommmitAllAnswer

            return axios.get(api, {params}).then((res)=>{
                return callbackHandler(api, res);
            })
        },
        // 获取房树人全部题目接口
        ['FSR_GET_QUESTIONS'](context, {env, params}={}){
            const api = APIS.fsrGetUserModuleQuestions;
            return axios.get(api, {params}).then((res)=>{
                callbackHandler(api, res);
                return res.data;
            })
        },
        // 获取房树人全部题目接口
        ['FSR_GET_QUESTIONS_V2'](context, {env, params}={}){
            const api = APIS.fsrGetUserModuleQuestionsV2;
            return axios.get(api, {params}).then((res)=>{
                callbackHandler(api, res);
                return res.data;
            })
        },
         // 房树人提交图片题答案
         ['FSR_COMMIT_IMAGE_ANSWERS_V2'](context, {env, params}={}){
            const api = APIS.fsrCommitImageAnswers
            return axios.post(api, qs.stringify(params)).then((res)=>{
                return callbackHandler(api, res);
            })
        },
        //房树人提前全部答案
        [`FSR_SET_SCALE_COMMIT_ALL`](context, {env, params}={}){
            const api = APIS.fsrCommitAll;
            return axios.get(api, {params}).then((res)=>{
                callbackHandler(api, res);
                return res.data
            })
        },
        //房树人提前全部答案
        [`FSR_FETCH_IMG`](context, {env, params}={}){
            const api = APIS.fsrFetchImage;
            return axios.get(api, {params}).then((res)=>{
                callbackHandler(api, res);
                return res.data
            })
        },
        // 获取雨中人全部题目接口
        ['YZR_GET_QUESTIONS'](context, {env, params}={}){
            const api = APIS.yzrGetUserModuleQuestions;
            return axios.get(api, {params}).then((res)=>{
                callbackHandler(api, res);
                return res.data;
            })
        },
        [`YZR_FETCH_IMG`](context, {env, params}={}){
            const api = APIS.yzrFetchImage;
            return axios.get(api, {params}).then((res)=>{
                callbackHandler(api, res);
                return res.data
            })
        },
        // 儿童绘画前后测提交全部答案
        [`CHILD_SET_SCALE_COMMIT_ALL`](context, {env, params}={}){
            const api = APIS.childCommitAll;
            return axios.get(api, {params}).then((res)=>{
                callbackHandler(api, res);
                return res.data
            })
        },
        // 儿童绘画获取中间测全部问题
        ['GET_CHILD_MID_QUESTIONS'](context, {env, params}={}){
            const api = APIS.childMidQuestions;
            console.log('--- GET_CHILD_MID_QUESTIONS --- api', api)
            return axios.get(api, {params}).then((res)=>{
                return callbackHandler(api, res);
            })
        },
        // 儿童绘画前后测提交全部答案
        [`CHILD_MID_SET_SCALE_COMMIT_ALL`](context, {env, params}={}){
            const api = APIS.childMidCommitAll;
            return axios.get(api, {params}).then((res)=>{
                callbackHandler(api, res);
                return res.data
            })
        },
        // 儿童绘画获取用户作品图片
        [`CHILD_FETCH_IMG`](context, {env, params}={}){
            const api = APIS.childGetPictureUrl;
            return axios.get(api, {params}).then((res)=>{
                callbackHandler(api, res);
                return res.data
            })
        },
        /**
         * 获取ui皮肤接口
         */
        // [`GET_QUESTIONS_OPTIONS`](context, {env, params}={}){
        //     const api = APIS.getQuestionnaire;
        //     return axios.get(api, {params}).then((res)=>{
        //         return callbackHandler(api, res);
        //     })
        // }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/answer.js